import { Component, EventEmitter, inject, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { NotificationView } from '@api-proxies';
import { IconSanitizerService } from 'ngx-lib';
import { NotificationItemComponent } from '../notification-item/notification-item.component';

export interface INotificationListPaginationConfig {
    currentPage: number;
    pagesCount: number;
    totalCount: number;
    pageSize?: number;
}

@Component({
    selector: 'app-notifications-list',
    templateUrl: './notifications-list.component.html',
    styleUrls: ['./notifications-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NotificationItemComponent]
})
export class NotificationsListComponent {
    private readonly iconSanitizer = inject(IconSanitizerService);

    @Input()
    notifications?: NotificationView[];

    @Output()
    notificationChange: EventEmitter<void>;

    @Input()
    paginationConfig?: INotificationListPaginationConfig;

    @Output()
    paginationConfigChange: EventEmitter<INotificationListPaginationConfig> =
        new EventEmitter<INotificationListPaginationConfig>();

    @Input()
    isPanel?: boolean;

    notificationIcon: SafeHtml = this.iconSanitizer.getIcon('notificationList');

    constructor() {
        this.notificationChange = new EventEmitter<void>();
        this.isPanel = false;
    }

    onNotificationChange() {
        this.notificationChange.emit();
    }

    goNext() {
        if (!this.canGoNext()) return;
        this.changePage(this.paginationConfig!.currentPage + 1);
    }

    canGoNext() {
        if (!this.paginationConfig?.currentPage || !this.paginationConfig?.pagesCount) return false;
        return this.paginationConfig?.currentPage < this.paginationConfig?.pagesCount;
    }

    private changePage(page: number) {
        if (!this.paginationConfig) return;
        this.paginationConfigChange.emit({ ...this.paginationConfig, currentPage: page });
    }
}
